import { Cell, Grid, Text, TextField, VFlow } from 'bold-ui'
import { usePecField } from 'components/form'

import { metaNotificacaoAgravo, NotificacaoFormModel } from '../model-notificacaoAgravo'

const meta = metaNotificacaoAgravo.notificacao

export function NotificacaoStep() {
  const {
    input: { value },
  } = usePecField<NotificacaoFormModel>({
    name: meta.absolutePath(),
    subscription: { value: true },
  })

  return (
    <VFlow>
      <Grid>
        <Cell size={12}>
          <TextField
            label='Unidade de saúde da notificação'
            value={value?.unidadeSaude?.nome ?? ''}
            disabled
            required
          />
        </Cell>

        <Cell size={12}>
          <TextField label='Município da notificação' value={value?.municipio?.nome ?? ''} disabled required />
        </Cell>

        <Cell size={12}>
          <TextField label='UF da notificação' value={value?.uf?.nome ?? ''} disabled required />
        </Cell>

        <Cell size={12}>
          <Text>Ao finalizar o atendimento, o formulário de notificação de agravo será enviado ao e-SUS SINAN</Text>
        </Cell>
      </Grid>
    </VFlow>
  )
}
